<!-- FFルールグループ -->
<div class="p-fare-panel__body-item js-fix-height-3" id="p-fare-panel__body3-{{ slideNum }}">
  <ul class="c-available-list">
    <!-- 予約変更可否 -->
    <li class="c-available-list__item">
      <!-- 予約変更可能、手数料なし -->
      <ng-container *ngIf="this.fareFamiliesRule.itineraryPermit === 'free'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.itineraryPermitted' | staticMsg"></div>
      </ng-container>
      <!-- 予約変更可能、手数料あり -->
      <ng-container *ngIf="this.fareFamiliesRule.itineraryPermit === 'withPenalty'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.itineraryPermittedWithFee' | staticMsg"></div>
      </ng-container>
      <!-- 予約変更不可 -->
      <ng-container *ngIf="this.fareFamiliesRule.itineraryPermit === 'unavailable'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.itineraryNotPermitted' | staticMsg"></div>
      </ng-container>
    </li>
    <!-- 払戻可否 -->
    <li class="c-available-list__item">
      <!-- 手数料なしで払い戻し可能 -->
      <ng-container *ngIf="this.fareFamiliesRule.refundPermit === 'free'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.refundPermitted' | staticMsg"></div>
      </ng-container>
      <!-- 手数料ありで払い戻し可能 -->
      <ng-container *ngIf="this.fareFamiliesRule.refundPermit === 'withPenalty'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.refundPermittedWithFee' | staticMsg"></div>
      </ng-container>
      <!-- 払い戻し不可 -->
      <ng-container *ngIf="this.fareFamiliesRule.refundPermit === 'unavailable'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.refundNotPermitted' | staticMsg"></div>
      </ng-container>
    </li>
    <!-- 無料預け入れ手荷物個数 -->
    <!-- 個数の返却がある場合のみ表示 -->
    <ng-container *ngIf="this.fareFamiliesRule.isReceivedFreeBaggagePcs">
      <li class="c-available-list__item">
        <!-- 1個以上の場合、可能 -->
        <ng-container *ngIf="this.fareFamiliesRule.freeBaggagePcs! > 0">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
          </div>
          <div
            class="c-available-list__item-title"
            [innerHTML]="'label.freeBaggagePcs' | staticMsg : { '0': this.fareFamiliesRule.freeBaggagePcs }"
          ></div>
        </ng-container>
        <!-- 0個の場合、不可 -->
        <ng-container *ngIf="this.fareFamiliesRule.freeBaggagePcs! <= 0">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
          </div>
          <div class="c-available-list__item-title" [innerHTML]="'label.notFreeBaggage' | staticMsg"></div>
        </ng-container>
      </li>
    </ng-container>
    <!-- 無料機内持ち込み手荷物個数 -->
    <!-- 個数の返却がある場合のみ表示 -->
    <ng-container *ngIf="this.fareFamiliesRule.isReceivedCarryOnBaggage">
      <li class="c-available-list__item">
        <!-- 1個以上の場合、可能 -->
        <ng-container *ngIf="this.fareFamiliesRule.carryOnBaggage! > 0">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
          </div>
          <div
            class="c-available-list__item-title"
            [innerHTML]="'label.carryOnBaggagePcs' | staticMsg : { '0': this.fareFamiliesRule.carryOnBaggage }"
          ></div>
        </ng-container>
        <!-- 0個の場合、不可 -->
        <ng-container *ngIf="this.fareFamiliesRule.carryOnBaggage! === 0">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
          </div>
          <div class="c-available-list__item-title" [innerHTML]="'label.notCarryOnBaggage' | staticMsg"></div>
        </ng-container>
      </li>
    </ng-container>
    <!-- 事前追加手荷物 -->
    <li class="c-available-list__item">
      <!-- 事前追加手荷物申し込み可能 -->
      <ng-container *ngIf="this.fareFamiliesRule.isFirstBaggagePermitted">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.firstBaggagePermitted' | staticMsg"></div>
      </ng-container>
      <!-- 事前追加手荷物申し込み不可 -->
      <ng-container *ngIf="!this.fareFamiliesRule.isFirstBaggagePermitted">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.firstBaggageNotPermitted' | staticMsg"></div>
      </ng-container>
    </li>
  </ul>
</div>
<!-- セグメント情報 セグメントの分ループ -->
<ng-container *ngFor="let segment of this.segmentList; index as segmentIndex">
  <div #fixHeight[3] class="p-fare-panel__body-item js-fix-height-4" id="p-fare-panel__body4-{{ slideNum }}">
    <div class="p-fare-panel__body-item-title">
      <!-- 出発地 -->
      {{ segment.departureAirport }}
      <span class="p-fare-panel__body-item-to">
        <span class="u-visually-hidden" [innerHTML]="'label.section' | staticMsg"></span>
        <span aria-hidden="true">{{ 'label.symbolBetweenSection' | staticMsg }}</span>
      </span>
      <!-- 到着地 -->
      {{ segment.arrivalAirport }}
    </div>
    <ul class="c-available-list">
      <li class="c-available-list__item">
        <!-- (25-37) 座席指定料金 -->
        <!-- 座席指定可(有料) -->
        <ng-container *ngIf="segment.seatReservationFee === 'chargeable'">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
          </div>
          <div class="c-available-list__item-title" [innerHTML]="'label.chargeableSeatAssign2' | staticMsg"></div>
        </ng-container>
        <!-- 座席指定可(無料) -->
        <ng-container *ngIf="segment.seatReservationFee === 'included'">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
          </div>
          <div class="c-available-list__item-title" [innerHTML]="'label.asrFree' | staticMsg"></div>
        </ng-container>
        <!-- 座席指定不可 -->
        <ng-container *ngIf="segment.seatReservationFee === 'notOffered'">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
          </div>
          <div
            class="c-available-list__item-title"
            [innerHTML]="'label.asr.chargeableType.impossible.sp' | staticMsg"
          ></div>
        </ng-container>
        <!-- (25-38) シートマップ -->
        <!-- NHグループ運航便もしくは国内線の場合表示 -->
        <ng-container *ngIf="!isAnaApl && segment.isShowSeatmap">
          <div class="c-available-list__item-contents">
            <p class="p-fare-panel__body-item-text">
              <a
                id="seatmap-link-{{ segmentIndex }}"
                class="p-fare-panel__body-item-text-link"
                href="javascript:void(0)"
                (throttleClick$)="
                  this.seatmapReferenceParams(
                    segment.departureLocationCode,
                    segment.arrivalLocationCode,
                    segment.departureDateTime,
                    segment.marketingAirlineCode,
                    segment.marketingFlightNumber,
                    segment.bookingClass
                  )
                "
                aswThrottleClick
              >
                <span class="p-fare-panel__body-item-text-link u-visually-hidden">{{
                  segment.marketingAirlineCode! + segment.marketingFlightNumber
                }}</span>
                <span [innerHTML]="'link.seatMap' | staticMsg"></span>
                <img
                  class="c-text-link-external"
                  src="assets/images/icon_external_primary_16.svg"
                  width="16"
                  height="16"
                  alt="{{ 'alt.openLinkInNewTab' | staticMsg }}"
                />
              </a>
            </p>
          </div>
        </ng-container>
      </li>
      <!-- ANAカウチ利用可否 -->
      <!-- ANAカウチ利用可が１つ以上ある場合表示 -->
      <ng-container *ngIf="segment.isCouchDisplay">
        <li class="c-available-list__item">
          <!-- 当該セグメントと当該FFの組み合わせのANAカウチ利用可能 -->
          <ng-container *ngIf="segment.isEnabledAnaCouch">
            <div class="c-available-list__item-icon">
              <img
                src="assets/images/icon_feature_available_24.svg"
                width="24"
                height="24"
                alt="{{ 'alt.anaCouch' | staticMsg }}"
              />
            </div>
            <div class="c-available-list__item-title">
              <span class="c-ana-couchii-icon01">
                <img
                  class="c-ana-couchii-icon01__img"
                  src="assets/images/logo_ana_couchii.svg"
                  alt="{{ 'alt.anaCouchii' | staticMsg }}"
                  width="118"
                  height="20"
                  aria-hidden="true"
                />
              </span>
            </div>
          </ng-container>
          <!-- 当該セグメントと当該FFの組み合わせのANAカウチ利用不可 -->
          <ng-container *ngIf="!segment.isEnabledAnaCouch">
            <div class="c-available-list__item-icon">
              <img
                src="assets/images/icon_feature_not_available_24.svg"
                width="24"
                height="24"
                alt="{{ 'alt.notAnaCouch' | staticMsg }}"
              />
            </div>
            <div class="c-available-list__item-title">
              <span class="c-ana-couchii-icon01">
                <img
                  class="c-ana-couchii-icon01__img"
                  src="assets/images/logo_ana_couchii.svg"
                  alt="{{ 'alt.anaCouchii' | staticMsg }}"
                  width="118"
                  height="20"
                  aria-hidden="true"
                />
              </span>
            </div>
          </ng-container>
        </li>
      </ng-container>

      <!-- アップグレード案内 -->
      <!-- アップグレード案内　がtrue(表示可)の場合 -->
      <ng-container *ngIf="segment.isShowUpgrade">
        <li class="c-available-list__item">
          <!-- アップグレード可否　※チェックアイコン部分 -->
          <div class="c-available-list__item-icon">
            <ng-container *ngIf="segment.isEnabledUpgrade">
              <img
                src="assets/images/icon_feature_available_24.svg"
                width="24"
                height="24"
                alt="{{ 'alt.upgrade' | staticMsg }}"
              />
            </ng-container>
            <ng-container *ngIf="!segment.isEnabledUpgrade">
              <img
                src="assets/images/icon_feature_not_available_24.svg"
                width="24"
                height="24"
                alt="{{ 'alt.upgradeNotPermitted' | staticMsg }}"
              />
            </ng-container>
          </div>
          <div class="c-available-list__item-title" [innerHTML]="'label.upgrade1' | staticMsg"></div>
          <div class="c-available-list__item-contents">
            <div class="c-remaining-seats">
              <!-- アップグレード詳細情報取得 -->
              <div class="c-remaining-seats__load">
                <button
                  id="remaining-seats-load-btn-{{ segmentIndex }}"
                  class="c-remaining-seats__btn custom-remaining-seats"
                  [disabled]="!segment.isEnabledSeatAcquisition || this.allUpgradeLink"
                  type="button"
                  (click)="
                    this.upgradeDetailInformation(
                      segment,
                      segmentIndex,
                      segment.segmentId,
                      segment.departureLocationCode,
                      segment.arrivalLocationCode,
                      segment.departureDateTime,
                      segment.marketingAirlineCode,
                      segment.marketingFlightNumber,
                      this.segment.upgradeInfo
                    )
                  "
                >
                  <span
                    class="c-remaining-seats__btn-text"
                    [innerHTML]="'label.seatAcquisition' | staticMsg"
                    aria-hidden="true"
                  ></span>
                  <ng-container *ngIf="segment.isEnabledSeatAcquisition">
                    <span
                      class="u-visually-hidden"
                      [innerHTML]="
                        'reader.seatAcquisition'
                          | staticMsg
                            : { '0': segment.departureAirport, '1': segment.arrivalAirport, '2': fareFamilyName }
                      "
                    ></span>
                  </ng-container>
                  <span class="c-remaining-seats__btn-icon">
                    <img
                      *ngIf="!segment.isEnabledSeatAcquisition || this.allUpgradeLink; else upgradable"
                      src="assets/images/icon_arrow_down_gray60_20.svg"
                      width="20"
                      height="20"
                    />
                    <ng-template #upgradable>
                      <img src="assets/images/icon_arrow_down_primary_20.svg" width="20" height="20" />
                    </ng-template>
                  </span>
                </button>
              </div>
              <!-- アップグレード空席状況 アップグレード可 の場合、色付きアイコン表示-->
              <ng-container *ngIf="segment.isEnabledUpgrade">
                <dl class="c-remaining-seats__data">
                  <!-- キャビンクラス -->
                  <!-- アップグレード対象リスト分繰り返し -->
                  <ng-container
                    *ngFor="let cabinClassUpgradeInfo of this.segment.upgradeInfo?.cabinClassUpgradeInfoList"
                  >
                    <!-- プレミアムエコノミー -->
                    <ng-container *ngIf="cabinClassUpgradeInfo.cabinClass === 'ecoPremium'">
                      <div class="c-remaining-seats__data-item">
                        <dt class="c-remaining-seats__data-title-not-color">
                          <img
                            src="assets/images/icon_available_premium_economy_28.svg"
                            *ngIf="
                              cabinClassUpgradeInfo.seatStatus &&
                              verifiableSeatStatus.includes(cabinClassUpgradeInfo.seatStatus)
                            "
                            width="118"
                            height="20"
                            alt="{{ 'alt.upgradePremium' | staticMsg }}"
                          />
                          <img
                            src="assets/images/icon_available_not_premium_economy_28.svg"
                            *ngIf="
                              cabinClassUpgradeInfo.seatStatus &&
                              notVerifiableSeatStatus.includes(cabinClassUpgradeInfo.seatStatus)
                            "
                            width="118"
                            height="20"
                            alt="{{ 'alt.upgradePremium' | staticMsg }}"
                          />
                        </dt>
                        <!-- available(残席あり(残席数は不明)) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'available'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.available' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- waitlisting(空席待ち) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'waitlisting'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="
                              'label.upgradeAvailabilityStatus.waitlisting'
                                | staticMsg : { '0': cabinClassUpgradeInfo.vacancyNum }
                            "
                          ></dd>
                        </ng-container>
                        <!-- acquired(取得済) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'acquired'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="
                              'label.upgradeAvailabilityStatus.acquired'
                                | staticMsg : { '0': cabinClassUpgradeInfo.vacancyNum }
                            "
                          ></dd>
                        </ng-container>
                        <!-- noSetting(設定なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'noSetting'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.noSetting' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- occupied(残席なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'occupied'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.occupied' | staticMsg"
                          ></dd>
                        </ng-container>
                      </div>
                    </ng-container>
                    <!--  ビジネス -->
                    <ng-container *ngIf="cabinClassUpgradeInfo.cabinClass === 'business'">
                      <div class="c-remaining-seats__data-item">
                        <dt class="c-remaining-seats__data-title-not-color">
                          <img
                            src="assets/images/icon_available_business_28.svg"
                            *ngIf="
                              cabinClassUpgradeInfo.seatStatus &&
                              verifiableSeatStatus.includes(cabinClassUpgradeInfo.seatStatus)
                            "
                            width="118"
                            height="20"
                            alt="{{ 'alt.upgradeBusiness' | staticMsg }}"
                          />
                          <img
                            src="assets/images/icon_available_not_business_28.svg"
                            *ngIf="
                              cabinClassUpgradeInfo.seatStatus &&
                              notVerifiableSeatStatus.includes(cabinClassUpgradeInfo.seatStatus)
                            "
                            width="118"
                            height="20"
                            alt="{{ 'alt.upgradeBusiness' | staticMsg }}"
                          />
                        </dt>
                        <!-- available(残席あり(残席数は不明)) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'available'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.available' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- waitlisting(空席待ち) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'waitlisting'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.waitlisting' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- acquired(取得済) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'acquired'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="
                              'label.upgradeAvailabilityStatus.acquired'
                                | staticMsg : { '0': cabinClassUpgradeInfo.vacancyNum }
                            "
                          ></dd>
                        </ng-container>
                        <!-- noSetting(設定なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'noSetting'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.noSetting' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- occupied(残席なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'occupied'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.occupied' | staticMsg"
                          ></dd>
                        </ng-container>
                      </div>
                    </ng-container>
                    <!--  ファースト -->
                    <ng-container *ngIf="cabinClassUpgradeInfo.cabinClass === 'first'">
                      <div class="c-remaining-seats__data-item">
                        <dt class="c-remaining-seats__data-title-not-color">
                          <img
                            src="assets/images/icon_available_first_28.svg"
                            *ngIf="
                              cabinClassUpgradeInfo.seatStatus &&
                              verifiableSeatStatus.includes(cabinClassUpgradeInfo.seatStatus)
                            "
                            width="118"
                            height="20"
                            alt="{{ 'alt.upgradeFirst' | staticMsg }}"
                          />
                          <img
                            src="assets/images/icon_available_not_first_28.svg"
                            *ngIf="
                              cabinClassUpgradeInfo.seatStatus &&
                              notVerifiableSeatStatus.includes(cabinClassUpgradeInfo.seatStatus)
                            "
                            width="118"
                            height="20"
                            alt="{{ 'alt.upgradeFirst' | staticMsg }}"
                          />
                        </dt>
                        <!-- available(残席あり(残席数は不明)) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'available'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.available' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- waitlisting(空席待ち) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'waitlisting'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.waitlisting' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- acquired(取得済) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'acquired'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="
                              'label.upgradeAvailabilityStatus.acquired'
                                | staticMsg : { '0': cabinClassUpgradeInfo.vacancyNum }
                            "
                          ></dd>
                        </ng-container>
                        <!-- noSetting(設定なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'noSetting'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.noSetting' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- occupied(残席なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'occupied'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.occupied' | staticMsg"
                          ></dd>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </dl>
              </ng-container>

              <!-- アップグレード空席状況 アップグレード不可の場合、グレーアイコン表示-->
              <ng-container *ngIf="!segment.isEnabledUpgrade">
                <dl class="c-remaining-seats__data">
                  <!-- キャビンクラス -->
                  <!-- アップグレード対象リスト分繰り返し -->
                  <ng-container
                    *ngFor="let cabinClassUpgradeInfo of this.segment.upgradeInfo?.cabinClassUpgradeInfoList"
                  >
                    <!-- プレミアムエコノミー アップグレード不可 -->
                    <ng-container *ngIf="cabinClassUpgradeInfo.cabinClass === 'ecoPremium'">
                      <div class="c-remaining-seats__data-item">
                        <dt class="c-remaining-seats__data-title-not-color">
                          <img
                            src="assets/images/icon_available_not_premium_economy_28.svg"
                            width="118"
                            height="20"
                            alt="{{ 'alt.upgradePremium' | staticMsg }}"
                          />
                        </dt>
                        <!-- noSetting(設定なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'noSetting'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.noSetting' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- occupied(残席なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'occupied'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.occupied' | staticMsg"
                          ></dd>
                        </ng-container>
                      </div>
                    </ng-container>
                    <!-- プレミアム アップグレード不可 -->
                    <ng-container *ngIf="cabinClassUpgradeInfo.cabinClass === 'Premium'">
                      <div class="c-remaining-seats__data-item">
                        <dt class="c-remaining-seats__data-title-not-color">
                          <img
                            src="assets/images/icon_available_not_premium_class_28.svg"
                            width="118"
                            height="20"
                            alt="{{ 'alt.upgradePremium' | staticMsg }}"
                          />
                        </dt>
                        <!-- noSetting(設定なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'noSetting'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.noSetting' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- occupied(残席なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'occupied'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.occupied' | staticMsg"
                          ></dd>
                        </ng-container>
                      </div>
                    </ng-container>
                    <!--  ファースト アップグレード不可 -->
                    <ng-container *ngIf="cabinClassUpgradeInfo.cabinClass === 'first'">
                      <div class="c-remaining-seats__data-item">
                        <dt class="c-remaining-seats__data-title-not-color">
                          <img
                            src="assets/images/icon_available_not_first_28.svg"
                            width="118"
                            height="20"
                            alt="{{ 'alt.upgradeFirst' | staticMsg }}"
                          />
                        </dt>
                        <!-- noSetting(設定なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'noSetting'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.noSetting' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- occupied(残席なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'occupied'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.occupied' | staticMsg"
                          ></dd>
                        </ng-container>
                      </div>
                    </ng-container>
                    <!--  ビジネス アップグレード不可 -->
                    <ng-container *ngIf="cabinClassUpgradeInfo.cabinClass === 'business'">
                      <div class="c-remaining-seats__data-item">
                        <dt class="c-remaining-seats__data-title-not-color">
                          <img
                            src="assets/images/icon_available_not_business_28.svg"
                            width="118"
                            height="20"
                            alt="{{ 'alt.upgradeBusiness' | staticMsg }}"
                          />
                        </dt>
                        <!-- noSetting(設定なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'noSetting'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.noSetting' | staticMsg"
                          ></dd>
                        </ng-container>
                        <!-- occupied(残席なし) -->
                        <ng-container *ngIf="cabinClassUpgradeInfo.seatStatus === 'occupied'">
                          <dd
                            class="c-remaining-seats__data-contents"
                            [innerHTML]="'label.upgradeAvailabilityStatus.occupied' | staticMsg"
                          ></dd>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </dl>
              </ng-container>
            </div>
          </div>
        </li>
      </ng-container>
      <!-- 機内サービスアイコン表示欄 -->
      <ng-container
        *ngIf="
          segment.isEnabledMeal ||
          segment.isEnabledEntertainment ||
          segment.isEnabledShopping ||
          segment.isEnabledAmenity ||
          segment.isWiFiServiceAll ||
          segment.isWiFiServiceASegment ||
          segment.isEnabledLounge ||
          segment.isEnabledSeat
        "
      >
        <li class="c-available-list__item">
          <!-- 機内サービス可・不可 -->
          <ng-container>
            <div class="c-available-list__item-icon">
              <img
                src="assets/images/icon_feature_available_24.svg"
                width="24"
                height="24"
                alt="{{ 'alt.inFlightService' | staticMsg }}"
              />
            </div>
          </ng-container>
          <div class="c-available-list__item-title" [innerHTML]="'label.InFlightService' | staticMsg"></div>
          <div class="c-available-list__item-contents">
            <ul class="c-icon-tooltip-list">
              <!-- お食事、お飲み物 -->
              <ng-containter *ngIf="segment.tooltipMeal === 'S'">
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <asw-tooltip
                    [iconImage]="getTooltipIconImage('assets/images/icon_cakes_primary_24.svg', 'alt.tea', 24, 24)"
                    tooltipContent="{{ 'm_static_message-label.domesticMealType.S' | staticMsg }}"
                    [tooltipTop]="0"
                  >
                  </asw-tooltip>
                </li>
              </ng-containter>
              <ng-containter *ngIf="segment.tooltipMeal === 'M'">
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <asw-tooltip
                    [iconImage]="getTooltipIconImage('assets/images/icon_meal_primary_28.svg', 'alt.meal', 24, 24)"
                    tooltipContent="{{ 'm_static_message-label.domesticMealType.M' | staticMsg }}"
                    [tooltipTop]="0"
                  >
                  </asw-tooltip>
                </li>
              </ng-containter>
              <ng-containter *ngIf="segment.tooltipMeal === 'R'">
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <asw-tooltip
                    [iconImage]="getTooltipIconImage('assets/images/icon_meal_primary_28.svg', 'alt.lightMeal', 24, 24)"
                    tooltipContent="{{ 'm_static_message-label.domesticMealType.M' | staticMsg }}"
                    [tooltipTop]="0"
                  >
                  </asw-tooltip>
                </li>
              </ng-containter>
              <ng-containter *ngIf="segment.tooltipMeal === 'N'">
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <asw-tooltip
                    [iconImage]="getTooltipIconImage('assets/images/icon_drink_primary_24.svg', 'alt.noMeal', 24, 24)"
                    tooltipContent="{{ 'm_static_message-tooltip.noMeal' | staticMsg }}"
                    [tooltipTop]="0"
                  >
                  </asw-tooltip>
                </li>
              </ng-containter>
              <ng-containter
                *ngIf="
                  segment.tooltipMeal !== 'S' &&
                  segment.tooltipMeal !== 'M' &&
                  segment.tooltipMeal !== 'R' &&
                  segment.tooltipMeal !== 'N'
                "
              >
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <asw-tooltip
                    [iconImage]="getTooltipIconImage('assets/images/icon_meal_primary_28.svg', 'alt.meal', 24, 24)"
                    tooltipContent="{{
                      segment.tooltipMeal ? (segment.tooltipMeal | metaUrl | popupIndicator | linkStyle) : ''
                    }}"
                    [tooltipTop]="0"
                  >
                  </asw-tooltip>
                </li>
              </ng-containter>
              <!-- エンターテインメント -->
              <ng-containter *ngIf="segment.isEnabledEntertainment">
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <asw-tooltip
                    [iconImage]="
                      getTooltipIconImage(
                        'assets/images/icon_entertainment_primary_28.svg',
                        'alt.entertainment',
                        24,
                        24
                      )
                    "
                    tooltipContent="{{
                      segment.tooltipEntertainment
                        ? (segment.tooltipEntertainment | metaUrl | popupIndicator | linkStyle)
                        : ''
                    }}"
                    [tooltipTop]="0"
                  >
                  </asw-tooltip>
                </li>
              </ng-containter>
              <!-- ショッピング -->
              <ng-containter *ngIf="segment.isEnabledShopping">
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <asw-tooltip
                    [iconImage]="
                      getTooltipIconImage('assets/images/icon_shopping_primary_28.svg', 'alt.shopping', 24, 24)
                    "
                    tooltipContent="{{
                      segment.tooltipShopping ? (segment.tooltipShopping | metaUrl | popupIndicator | linkStyle) : ''
                    }}"
                    [tooltipTop]="0"
                  >
                  </asw-tooltip>
                </li>
              </ng-containter>
              <!-- アメニティ -->
              <ng-containter *ngIf="segment.isEnabledAmenity">
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <asw-tooltip
                    [iconImage]="
                      getTooltipIconImage('assets/images/icon_amenity_primary_28.svg', 'alt.amenities', 24, 24)
                    "
                    tooltipContent="{{
                      segment.tooltipAmenity ? (segment.tooltipAmenity | metaUrl | popupIndicator | linkStyle) : ''
                    }}"
                    [tooltipTop]="0"
                  >
                  </asw-tooltip>
                </li>
              </ng-containter>
              <!-- Wi-Fiサービス -->
              <!-- Wi-Fiサービスありのアイコン -->
              <ng-containter *ngIf="segment.isWiFiServiceAll && !segment.isWiFiServiceASegment">
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <button class="js-tooltip-btn" id="wi-fi-1" aria-controls="tooltip03" aria-expanded="false">
                    <img
                      src="assets/images/icon_wifi_primary_28.svg"
                      width="24"
                      height="24"
                      alt="{{ 'alt.wifiAvailable' | staticMsg }}"
                    />
                  </button>
                </li>
              </ng-containter>
              <!-- Wi-Fiサービス可能性ありのアイコン -->
              <ng-containter *ngIf="!segment.isWiFiServiceAll && segment.isWiFiServiceASegment">
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <button class="js-tooltip-btn" id="wi-fi-2" aria-controls="tooltip03" aria-expanded="false">
                    <img
                      src="assets/images/icon_wifi_possibly_28.svg"
                      width="24"
                      height="24"
                      alt="{{ 'alt.wifiSomeAvailable' | staticMsg }}"
                    />
                  </button>
                </li>
              </ng-containter>
              <!-- ラウンジ -->
              <ng-containter *ngIf="segment.isEnabledLounge">
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <asw-tooltip
                    [iconImage]="getTooltipIconImage('assets/images/icon_lounge_primary_28.svg', 'alt.lounge1', 24, 24)"
                    tooltipContent="{{
                      segment.tooltipLounge ? (segment.tooltipLounge | metaUrl | popupIndicator | linkStyle) : ''
                    }}"
                    [tooltipTop]="0"
                  >
                  </asw-tooltip>
                </li>
              </ng-containter>
              <!-- 座席 -->
              <ng-containter *ngIf="segment.isEnabledSeat">
                <li class="c-icon-tooltip-list__item js-tooltip">
                  <asw-tooltip
                    [iconImage]="getTooltipIconImage('assets/images/icon_seat_primary_28.svg', 'alt.seat', 24, 24)"
                    tooltipContent="{{
                      segment.tooltipSeat ? (segment.tooltipSeat | metaUrl | popupIndicator | linkStyle) : ''
                    }}"
                    [tooltipTop]="0"
                  >
                  </asw-tooltip>
                </li>
              </ng-containter>
            </ul>
          </div>
        </li>
      </ng-container>
      <!-- ラウンジ利用可否 ＝ 可(有料)-->
      <ng-container *ngIf="segment.loungeAvailableType === 'available'">
        <li class="c-available-list__item">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
          </div>
          <div class="c-available-list__item-title" [innerHTML]="'label.loungePaidAvailable' | staticMsg"></div>
        </li>
      </ng-container>
      <!-- ラウンジ利用可否 ＝ 可(無料)-->
      <ng-container *ngIf="segment.loungeAvailableType === 'free'">
        <li class="c-available-list__item">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
          </div>
          <div class="c-available-list__item-title" [innerHTML]="'label.loungeAvailable' | staticMsg"></div>
        </li>
      </ng-container>
      <!-- ラウンジ利用可否 ＝不可 の場合 -->
      <ng-container *ngIf="segment.loungeAvailableType === 'inadvisable'">
        <li class="c-available-list__item">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
          </div>
          <div
            class="c-available-list__item-title"
            [innerHTML]="'label.loungeAvailableType.inadvisable' | staticMsg"
          ></div>
        </li>
      </ng-container>
      <!-- ブッキングクラス -->
      <ng-container *ngIf="segment.isEnabledBookingClass">
        <li class="c-available-list__item">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_marker_24.svg" width="24" height="24" />
          </div>
          <div
            class="c-available-list__item-title"
            [innerHTML]="
              ('label.bookingClass' | staticMsg) + ' ' + ('label.colon' | staticMsg) + ' ' + segment.bookingClass
            "
          ></div>
        </li>
      </ng-container>
    </ul>
  </div>
</ng-container>
